import(/* webpackMode: "eager" */ "/home/runner/work/lovingnext/lovingnext/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/lovingnext/lovingnext/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lovingnext/lovingnext/src/app/components/home/ProofBar/CountUp.tsx");
